import React from 'react'
import { ACTOR_TYPE } from '@trustero/trustero-api-web/lib/attachment/attachment_pb'
import { DocumentObj } from 'src/adapter/AttachmentAdapter'
import { FlexAlign, FlexRow } from 'src/components/Reusable/Flex'
import {
  Tooltip,
  TooltipOverlayType,
  TooltipPositions,
} from 'src/components/Reusable/Tooltip/Tooltip'
import { getLinkerTooltipMessage } from 'src/lib/Linkers/Linkers.helpers'
import { DisconnectedLinkerIcon } from 'src/lib/Linkers/Linkers.styles'
import { getReceptorTemplate } from 'src/xgenerated'
import { ViewInSourceButton } from 'src/components/Reusable/Evidence/evidence.components'

export const DocumentSource = ({
  document,
  hasLinker,
  hasInvalidCreds,
  exceptions,
}: {
  document: DocumentObj
  hasLinker: boolean
  hasInvalidCreds: boolean
  exceptions: string
}): JSX.Element => {
  if (document.linkerModelId.length > 0) {
    const linkerTemplate = getReceptorTemplate(document.linkerModelId)
    const hasValidLinker = hasLinker && !hasInvalidCreds && !exceptions
    const message = getLinkerTooltipMessage(
      linkerTemplate.name,
      hasInvalidCreds,
      exceptions,
    )
    return (
      <Tooltip
        id={`linker-tooltip-${document.id}`}
        overlayType={TooltipOverlayType.popover}
        placement={TooltipPositions.top}
        tooltipBody={message}
        disabled={hasValidLinker}
        trigger={['hover', 'focus']}
      >
        <FlexRow align={FlexAlign.CENTER} gap={8}>
          {hasValidLinker ? (
            <linkerTemplate.logo height={16} width={16} />
          ) : (
            <DisconnectedLinkerIcon />
          )}
          {linkerTemplate.name}
        </FlexRow>
      </Tooltip>
    )
  }
  if (document.docImportLink && document.actor) {
    return (
      <ViewInSourceButton
        receptorModelId={document.actor}
        link={document.docImportLink}
      />
    )
  }
  switch (document.actortype) {
    case ACTOR_TYPE.TRUSTERO:
      return <p>Trustero</p>
    case ACTOR_TYPE.RECEPTOR:
      return <p>Receptor</p>
    case ACTOR_TYPE.USER:
    default:
      return <p>Upload</p>
  }
}
